import { useApi } from '~/api'
import { defineService } from '~/api/models/helpers'
import type { AuthArgs } from '~/api/models/index'

const queries = {
  getAll: {
    queryFn: () => useApi().licenses.getLicenses(),
    queryKey: () => ['allLicences'],
    options: {
      enabled: () => true
    }
  }
} as const

const mutations = {
  // Define mutations for creating, updating, and deleting licences here
} as const

export type LicenceService = ReturnType<typeof defineService<typeof queries, typeof mutations>>

export const registerService = (authArgs: AuthArgs): LicenceService =>
  defineService(authArgs, {
    queries,
    mutations
  })
